require('./ideaDetail');
require('./ideaList');
require('./ideaForm');